import { c as _c } from "react/compiler-runtime";
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { Typography } from '@/components/Typography';
import { cn } from '@/lib/cn';
export type FieldWarningProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
export function FieldWarning(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("rounded-lg bg-color-input-border bg-warning px-2 py-2.5 text-center w-full max-w-full", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <Typography variant="caption" as="div" noProse={true} className={t1} {...props}>{children}</Typography>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}